export default "__VITE_ASSET__Bsu2Jt5B__"